export enum PaymentStatus {
  Pending = 'PENDING',
  PartiallyPaid = 'PARTIALLY PAID',
  Paid = 'PAID',
}
